import Service from '../../../service/ServiceFactory';
import RoutePlanningUtil from './RoutePlanningUtil';

const componentBase = (G as any).base.ComponentBase;
const component = componentBase.extend({
    options: {
        router: { // 路况状态颜色
            state: {
                0: '#666',
                1: '#51D27F',
                2: '#FFD147',
                3: '#EA2121',
                4: '#B70808',
            },
            highlight: {
            },
        },
        locateLevel: 18, // IP定位，地图放大等级,
        midPointFlag: false,

    },
    initialize(options: any) {
        componentBase.prototype.initialize.call(this);
        this.map = options.map;
        Object.assign(this.options, options);
        this._initPathLayers();
        this._initService();
        this._initializePointDrawCommand();
        this.routeUtils = new RoutePlanningUtil({
            context: this,
        });
    },
    _initService() {
        // 路径规划
        this.WRPSService = Service.createService('RestWRPSService', {}, this.options.serviceConfig.egis);
        // 地名搜索
        this.wpssService = Service.createService('RestWPSSService', {}, this.options.serviceConfig.egis);

        this.WRGSService = Service.createService('RestWRGSService', {}, this.options.serviceConfig.egis);

        this.WILSService = Service.createService('RestWILSService', {}, this.options.serviceConfig.egis);

    },
    // 初始化图层
    _initPathLayers() {
        this.routeLayers = new egis.carto.ElementLayer({
            map: this.map,
            zIndex: 20,
        });
        this.map.addLayer(this.routeLayers);

        this.highlightLayer = new egis.carto.ElementLayer({
            map: this.map,
            zIndex: 20,
        });
        this.map.addLayer(this.highlightLayer);

        // 图层参数
        const networkLayerOpts = {
            id: 'networkLayer',
            name: '路径分析图层',
            zIndex: 20,
            opacity: 1.0, // 透明度
            visible: true, // 是否显示

        };
        this.networkLayer = new egis.carto.ElementLayer(networkLayerOpts);
        this.map.addLayer(this.networkLayer);
        if (!this.toolTipWare) {
            this.toolTipWare = new egis.widget.TooltipWare({ map: this.map });
        }
    },

    /**
     * 初始化地图标点命令
     */
    _initializePointDrawCommand() {
        const self = this;
        // 创建一个命令管理实例，用来管理所有命令（包括标绘命令）
        // const commandManager = new egis.gdm.CommandManager();
        // this.options.commandNotify = new egis.gdm.CommandNotify({
        //     manager: commandManager,
        // });
        // 创建一个空的点对象
        const markerSymbol = new egis.sfs.SimpleMarkerSymbol({
            offsetX: 0,
            offsetY: 0,
            fillColor: new egis.sfs.Color({ a: 255, r: 0, g: 0, b: 0 }),
            size: 6,
        });
        const point = new egis.sfs.Point({ spatialReference: this.map.spatialReference });
        const pointEle = new egis.sfs.Element({ geometry: point, symbol: markerSymbol });
        const pointPlot = new egis.plot.PlotTool({
            id: 'pointPlot22',
            drawTemplate: pointEle,
            algorithm: new egis.plot.PointAlgorithm(),
            elements: [pointEle],
            name: '点符号',
            plotLayer: this.networkLayer,
        });
        const nooptool = new egis.interact.NoopTool({
            id: 'NoopTool',
            cursor: 'pointer',
        });
        // 先取消上一个编辑
        if (this.plotEditTool) {
            this.plotEditTool.deactivate();
            this.plotEditTool = null;
        }
        const plotEditTool = new egis.plot.PlotEditTool({
            id: 'plotEditTool',
            layer: this.networkLayer,
        });
        this.plotEditTool = plotEditTool;
        // 将命令放到命令管理中统一管理
        this.options.commandManager.add(pointPlot);
        this.options.commandManager.add(nooptool);
        this.options.commandManager.add(plotEditTool);
        // 标绘编辑采用的选中绘制集合
        const graphicSet = new egis.carto.GraphicSelectionSet();
        // 命令构造器
        this.options.commandManager.onCreate({
            map: this.map,
            commandNotify: this.options.commandNotify,
            graphicSelectionSet: graphicSet,
            spatialRef: {
                srid: this.map.spatialReference,
            },
        });
        let activeButton: any = {};
        pointPlot.onEndDraw = function (plotElement: any) {
            self.options.commandNotify.activeCommand('NoopTool');
            activeButton = Object.assign({}, this.data_activeButton);
            const id = self.routeUtils._getPointId(activeButton.position, activeButton.iconClass);
            if (self.networkLayer.contains(id)) {
                self.networkLayer.remove(self.networkLayer.find(id));
            }
            self.networkLayer.remove(plotElement);
            const symbol = self.routeUtils._getPointSymbol(activeButton.iconClass);
            const ele = new egis.sfs.Element({
                id,
                geometry: plotElement.elements[0].geometry,
                symbol,
            });
            self.networkLayer.add(ele);
            self.routeUtils.request2({ x: plotElement.elements[0].geometry.x, y: plotElement.elements[0].geometry.y })
                .then((res: any) => {
                    activeButton.location = {
                        x: res.x,
                        y: res.y,
                    };
                    activeButton.address = res.address;
                    self.fire('dealPathMainDatas', activeButton);
                })
                .catch((err: any) => {
                    console.error(err);
                });
        };
    },
    /**
     * 开启地图选点(前端调用)
     * @param data
     */
    startSelectPoint(data: any) {
        // 地图上标注起点
        this.options.commandNotify.activeCommand('pointPlot22');
        this.options.commandNotify.manager.commands.pointPlot22.data_activeButton = data;
    },

    load() {
        componentBase.prototype.load.call(this);
        if (!this.options.initLayer) { this._initPathLayers(); }
        if (!this.options.initService) { this._initService(); }
        if (!this.options.initCommand) { this._initializePointDrawCommand(); }
        this.routeUtils = new RoutePlanningUtil({
            context: this,
        });
    },
    unload() {
        componentBase.prototype.unload.call(this);
        if (this.routeLayers) {
            this.routeLayers.clear();
        }
        if (this.networkLayer) {
            this.networkLayer.clear();
        }
        if (this.highlightLayer) {
            this.highlightLayer.clear();
        }
        if (this.plotEditTool) {
            this.options.commandNotify.activeCommand('NoopTool');
            // this.plotEditTool.deactivate();
            this.plotEditTool = null;
        }
        if (this.toolTipWare) {
            this.toolTipWare.clear();
        }
    },

    /**
     * 查询驾车路径
     * @param opts
     */
    queryPath(opts: any) {
        this.routeUtils.clearRouteResults();
        const origin = [0, 0];
        const destination = [0, 0];
        const wayPoints = [];
        const strategy = isNaN(opts.style) ? 2 : opts.style;
        for (let i = 0; i < opts.stops.length; i++) {
            const x = parseFloat(opts.stops[i].lon);
            const y = parseFloat(opts.stops[i].lat);
            if (i === 0) {
                origin[0] = x;
                origin[1] = y;
            } else if (i === opts.stops.length - 1) {
                destination[0] = x;
                destination[1] = y;
            } else {
                wayPoints.push([x, y].join(','));
            }
        }
        const inputOpts = {
            origin: origin.join(','),
            destination: destination.join(','),
            waypoints: '',
            strategy,
        };
        if (wayPoints.length > 0) {
            inputOpts.waypoints = wayPoints.join('|');
            this.options.midPointFlag = true;
        }
        const routeInput = new egis.ews.DrivingInput(inputOpts);
        return new Promise((resolve, reject) => {
            this.WRPSService.driving(routeInput).then((result: any) => {
                if (result.status === -1) {
                    resolve({ error: result.msg });
                } else {
                    const data = this.routeUtils.parseRouteResult(result);
                    this.routeUtils.onRouteResult(data);
                    resolve(data);
                }
            });
        });
    },


    /**
     * 查询骑行路径
     * @param opts
     */
    queryPath_riding(opts: any) {
        this.routeUtils.clearRouteResults();
        const self = this;
        const origin = [0, 0];
        const destination = [0, 0];
        for (let i = 0; i < opts.stops.length; i++) {
            const x = parseFloat(opts.stops[i].lon);
            const y = parseFloat(opts.stops[i].lat);
            if (i === 0) {
                origin[0] = x;
                origin[1] = y;
            } else if (i === opts.stops.length - 1) {
                destination[0] = x;
                destination[1] = y;
            }
        }
        const inputOpts = {
            origin: origin.join(','),
            destination: destination.join(','),
            riding_type: opts.style,
        };
        const routeInput = new egis.ews.RidingInput(inputOpts);
        return new Promise((resolve, reject) => {
            try {
                self.WRPSService.riding(routeInput).then((result: any) => {
                    if (result.status === -1) {

                        if (result.msg === 'the straight_line_distance of start and end point exceed limit') {
                            resolve({ error: '起终点距离超过限制，请更改起终点或改换其他出行方式再查询。' });
                        } else {
                            resolve({ error: result.msg });
                        }
                    } else {
                        const data = self.routeUtils.parseRouteResult(result);
                        self.routeUtils.onRouteResult(data);
                        resolve(data);
                    }
                });
            } catch (e) {
                console.log(e);
            }
        });
    },

    /**
     * 查询骑行路径
     * @param opts
     */
    queryPath_walking(opts: any) {
        this.routeUtils.clearRouteResults();
        const self = this;
        const origin = [0, 0];
        const destination = [0, 0];
        for (let i = 0; i < opts.stops.length; i++) {
            const x = parseFloat(opts.stops[i].lon);
            const y = parseFloat(opts.stops[i].lat);
            if (i === 0) {
                origin[0] = x;
                origin[1] = y;
            } else if (i === opts.stops.length - 1) {
                destination[0] = x;
                destination[1] = y;
            }
        }
        const inputOpts = {
            origin: origin.join(','),
            destination: destination.join(','),
        };
        const routeInput = new egis.ews.WalkingInput(inputOpts);
        return new Promise((resolve, reject) => {
            self.WRPSService.walking(routeInput).then((result: any) => {
                if (result.status === -1) {
                    if (result.msg === 'the distance of path must less then 200Km') {
                        resolve({ error: '步行距离需要少于200公里，请更改起终点或改换其他出行方式再查询。' });
                    } else {
                        resolve({ error: result.msg });
                    }

                } else {
                    const data = self.routeUtils.parseRouteResult(result);
                    self.routeUtils.onRouteResult(data);
                    resolve(data);
                }
            });
        });
    },

    /**
     * 查询公交路径
     * @param opts
     * @param opts.strategy_incity 市内公交换乘策略：0 推荐,1 少换乘.2 少步行.3 不坐地铁,4 时间短,5 地铁优先
     * @param opts.strategy_intercity 跨域公交换乘策略：0 时间短，1 出发早，2 价格低
     * @param opts.Trans_type_intercity 跨城交通方式策略：0 火车优先，1 飞机优先，2 大巴优先
     */
    queryPath_bus(opts: any) {
        this.routeUtils.clearRouteResults();
        const origin = [0, 0];
        const destination = [0, 0];
        for (let i = 0; i < opts.stops.length; i++) {
            const x = parseFloat(opts.stops[i].lon);
            const y = parseFloat(opts.stops[i].lat);
            if (i === 0) {
                origin[0] = x;
                origin[1] = y;
            } else if (i === opts.stops.length - 1) {
                destination[0] = x;
                destination[1] = y;
            }
        }
        const inputOpts = {
            origin: origin.join(','),
            destination: destination.join(','),
            strategy_incity: opts.strategy_incity || 0,
            strategy_intercity: opts.strategy_intercity || 0,
            Trans_type_intercity: opts.Trans_type_intercity || 0,
            page_size: 10,
            page_index: 1,
        };
        const routeInput = new egis.ews.TransitInput(inputOpts);
        return new Promise((resolve, reject) => {
            this.WRPSService.transit(routeInput).then((result: any) => {
                if (result.status === -1) {
                    resolve({ error: result.msg });
                } else {
                    if (result.routes && result.routes.length > 0) {
                        this.routeUtils.showRoute_bus(result, 0);
                        resolve(result);
                    } else {
                        resolve({ error: '暂无适合公交方案！' });
                    }
                }
            });
        });
    },

    /**
     * 高亮指定线路(前端)
     * @param path
     */
    highlightBusRouteScheme(path: any) {
        this.highlightLayer.clear();
        const pathSymbol = new egis.sfs.SimpleLineSymbol({
            width: 10,
            color: new egis.sfs.Color({ a: 255, r: 225, g: 40, b: 40 }),
            style: 5,
        });
        const roadPathEle = new egis.sfs.Element({ geometry: path, symbol: pathSymbol });
        this.highlightLayer.add(roadPathEle);
        this.map.pan(path);
    },

    /**
     * 单击列表中路线，在地图高亮对应线路(前端)
     * @param item
     */
    showSingleRoad(item: any) {

        const pathPolyline = item.poly;
        if (pathPolyline instanceof egis.sfs.LineString ||
            pathPolyline instanceof egis.sfs.Polyline) {
            if (this.roadPathEle) {
                this.routeLayers.remove(this.roadPathEle);
            }
            let color;
            let pathSymbol;
            if (item.status || item.status === 0) {
                const color_ = this.options.symbolConfig.symbols.pathAnalysis.router.state[item.status];
                color = egis.sfs.Color.fromHex(color_);
                pathSymbol = new egis.sfs.SimpleLineSymbol({
                    width: 10,
                    color,
                    style: 5,
                });
            } else {
                pathSymbol = new egis.sfs.SimpleLineSymbol({
                    width: 8,
                    color: new egis.sfs.Color({ a: 255, r: 225, g: 40, b: 40 }),
                    style: 5,
                });
            }

            this.roadPathEle = new egis.sfs.Element({ geometry: pathPolyline, symbol: pathSymbol });
            this.routeLayers.add(this.roadPathEle);
            this.map.pan(pathPolyline);
            this.map.zoomOut();
        }
    },
    /**
     * 调转起终点(前端)
     * @param dataList
     */
    reversePoints(dataList: any) {
        this.networkLayer.clear();
        for (let i = 0; i < dataList.length; i++) {
            const data = dataList[i];
            const x = data.location.x;
            const y = data.location.y;
            this.currentPosition = i;

            const markerSymbol = this.routeUtils._getPointSymbol(data.iconClass);
            const point = new egis.sfs.Point({
                x,
                y,
                spatialReference: this.map.spatialReference,
            });
            const id = this.routeUtils._getPointId(data.position, data.iconClass);
            const pointEle = new egis.sfs.Element({ id, geometry: point, symbol: markerSymbol });
            this.networkLayer.add(pointEle);
        }
    },

    /**
     * 显示弹窗(前端)
     * @param item
     */
    showPopup(item: any) {
        this.toolTipWare.clear();
        const point = new egis.sfs.Point({
            x: item.location.lon,
            y: item.location.lat,
            spatialReference: this.map.spatialReference,
        });
        const telephone = item.telephone || '无';
        const address = item.address || '无';
        const contentTemplate = '<div ignore="2"><a id="closePoiPopBtn" style="float:right;cursor:pointer">X</a>' +
            '<label style="padding-top: 20px; display: block; white-space: nowrap;line-height: 20px; min-width: 220px;">' +
            '' + item.title + '</br>' +
            '电话:' + telephone + '</br>' +
            '地址:' + address +
            '</label>' +
            '</div>';
        const tooltip = new egis.widget.Tooltip({
            anchor: point,     // 提示在地图上停靠位置
            content: contentTemplate,  // 提示内容
            layerId: this.layer.getLayerId(), // 提示所在图层ID
            offset: [0, -20],     // 位置偏移量
            className: 'egis-tooltip',  // tooltip样式
        });
        this.toolTipWare.add(tooltip);
        this.map.setCenter(point);
        $('#closePoiPopBtn').on('click', () => {
            this.toolTipWare.clear();
            this.fire('closePopup');
        });
    },

    /**
     * 移除起点/途经点/终点(前端)
     * @param data
     */
    removePoint(data: any) {
        const id = this.routeUtils._getPointId(data.position, data.iconClass);
        if (this.networkLayer.contains(id)) {
            this.networkLayer.remove(this.networkLayer.find(id));
        }
        if (this.networkLayer.elements.length === 0) {
            this.routeLayers.clear();
            if (this.toolTipWare) { this.toolTipWare.clear(); }
            if (this.highlightLayer) { this.highlightLayer.clear(); }
        }
    },

    /**
     * 移除中间点(前端)
     */
    removeMidPoints() {
        const elements = this.networkLayer.elements;
        for (let i = elements.length - 1; i >= 0; i--) {
            if (elements[i].id.indexOf('middle') > -1) {
                this.networkLayer.remove(elements[i]);
            }
        }
    },

    /**
    * 隐藏回复中间点(前端)
    */
    resumeMidPoints() {
        const elements = this.networkLayer.elements;
        for (let i = elements.length - 1; i >= 0; i--) {
            if (elements[i].id.indexOf('middle') > -1) {
                this.networkLayer.showElement(elements[i], this.options.midPointFlag);
            }
        }
    },
    /**
     * 添加起点/途经点/终点
     * @param data
     */
    addPoint(data: any) {
        this.options.commandNotify.activeCommand('NoopTool');
        const x = data.location.x;
        const y = data.location.y;
        this.currentPosition = data.position;

        // 在地图上标注
        // let markerSymbol = new egis.sfs.SimpleMarkerSymbol({
        //     offsetX: 0,
        //     offsetY: 0,
        //     fillColor: new egis.sfs.Color({a: 255, r: 0, g: 0, b: 0}),
        //     size: 6
        // });
        const markerSymbol = this.routeUtils._getPointSymbol(data.iconClass);
        const point = new egis.sfs.Point({
            x,
            y,
            spatialReference: this.map.spatialReference,
        });
        const id = this.routeUtils._getPointId(data.position, data.iconClass);
        const pointEle = new egis.sfs.Element({ id, geometry: point, symbol: markerSymbol });
        if (this.networkLayer.contains(id)) {
            this.networkLayer.remove(this.networkLayer.find(id));
        }
        this.networkLayer.add(pointEle);
        this.map.zoomTo(12);
        this.map.setCenter(point);
    },

    /**
     * 增加终点
     * @param data
     */
    addEndPoint(data: any) {
        const t = data.t;
        // 地图上标注终点
        this.options.commandNotify.activeCommand('pointPlot22');
        this.options.commandNotify.manager.commands.pointPlot22.data_activeButton = t;
    },

    showBusRoute(steps: any) {
        this.routeUtils.showBusRoute(steps);
    },
    // 定位到指定线路
    showBusRouteSchemes(schemes: any) {
        this.highlightLayer.clear();
        const geoList = [];
        for (let m = 0; m < schemes.length; m++) {
            const schema = schemes[m];
            const path = schema.path;
            geoList.push(path);
        }
        const geoArr = G.utils.GeometryUtil.getGeometryEnvlop(geoList);
        this.map.pan(geoArr);
    },
});
export default component;
